import { MAX_SEED_VALUE } from "../constants/TextToImageConstants";

interface UseSeedValidationProps {
	onSeedChange: (seed: number | undefined) => void;
}

/**
 * Custom hook to handle seed input validation
 * Validates seed value to ensure it:
 * - Does not exceed MAX_SEED_VALUE (2147483647)
 * - Does not exceed 10 digits
 */
export const useSeedValidation = ({ onSeedChange }: UseSeedValidationProps) => {
	const handleSeedChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const value = e.target.value;

		// Allow empty value
		if (!value) {
			onSeedChange(undefined);
			return;
		}

		const parsedValue = parseFloat(value);

		// Check if the value exceeds the maximum allowed seed value
		if (parsedValue > MAX_SEED_VALUE) {
			return;
		}

		// Check if the value has more than 10 digits
		const numericValue = value.replace(/\D/g, "");
		if (numericValue.length > 10) {
			return;
		}

		onSeedChange(parsedValue);
	};

	return { handleSeedChange };
};
